import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import Home from '@/pages/Home';
import MovieDetail from '@/pages/MovieDetail';
import MyList from '@/pages/MyList';
import Community from '@/pages/Community';
import CreateThread from '@/pages/CreateThread';
import ThreadDetail from '@/pages/ThreadDetail';
import SearchResults from '@/pages/SearchResults';
import Login from '@/pages/Login';
import Profile from '@/pages/Profile';
import Discover from '@/pages/Discover';
import Movies from '@/pages/Movies';
import TvShows from '@/pages/TvShows';
import PostDetail from '@/pages/PostDetail';
import ProtectedRoute from '@/components/ProtectedRoute';
import Layout from '@/components/Layout';

function AppRouter() {
  return (
    <Layout>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/discover" element={<ProtectedRoute><Discover /></ProtectedRoute>} />
        <Route path="/movie" element={<ProtectedRoute><Movies /></ProtectedRoute>} />
        <Route path="/tv" element={<ProtectedRoute><TvShows /></ProtectedRoute>} />
        <Route path="/movie/:id" element={<ProtectedRoute><MovieDetail /></ProtectedRoute>} />
        <Route path="/tv/:id" element={<ProtectedRoute><MovieDetail /></ProtectedRoute>} />
        <Route path="/post/:id" element={<ProtectedRoute><PostDetail /></ProtectedRoute>} />

        <Route path="/my-list" element={<ProtectedRoute><MyList /></ProtectedRoute>} />
        <Route path="/profile/:id?" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/community" element={<ProtectedRoute><Community /></ProtectedRoute>} />
        <Route path="/community/new" element={<ProtectedRoute><CreateThread /></ProtectedRoute>} />
        <Route path="/community/:id" element={<ProtectedRoute><ThreadDetail /></ProtectedRoute>} />
        <Route path="/search" element={<ProtectedRoute><SearchResults /></ProtectedRoute>} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
